import { LoadBankType } from "./Enums";

export class LoadBankParameters {
    locCode: string = '';
    loadBankType: LoadBankType = LoadBankType.Load;
}